module.exports = __webpack_public_path__ + "static/img/banner.67ad377.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/reservation/play/banner.jpg
// module id = ycrP
// module chunks = 3